module.exports = __webpack_public_path__ + "media/packs/images/partners/cashback-68cff0fc101b7d19c5bbdf2383e497b6.jpg";